import { render } from "./KnowledgeCard.vue?vue&type=template&id=24ceab42&scoped=true"
import script from "./KnowledgeCard.vue?vue&type=script&lang=js"
export * from "./KnowledgeCard.vue?vue&type=script&lang=js"

import "./KnowledgeCard.vue?vue&type=style&index=0&id=24ceab42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ceab42"]])

export default __exports__